import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Section = styled(motion.section)`
  margin-bottom: 60px;
  background: rgba(255, 255, 255, 0.97);
  padding: 50px;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-card);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-card-hover);
  }
`;

export const Title = styled(motion.h2)`
  color: var(--color-primary);
  font-size: 2.4rem;
  margin-bottom: 35px;
  font-family: 'Quicksand', sans-serif;
  font-weight: 700;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -12px;
    left: 0;
    width: 100px;
    height: 4px;
    background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-primary-light) 100%);
    border-radius: 2px;
  }
`;

export const SubTitle = styled(motion.h3)`
  color: var(--color-primary-dark);
  font-size: 1.8rem;
  margin: 40px 0 25px;
  font-family: 'Quicksand', sans-serif;
  font-weight: 600;
`;

export const Paragraph = styled(motion.p)`
  font-size: 1.15rem;
  line-height: 1.9;
  margin-bottom: 25px;
  color: var(--color-text);
  font-family: 'Quicksand', sans-serif;
  font-weight: 400;
  letter-spacing: 0.2px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ContentBlock = styled.div`
  margin: 30px 0;
  padding: 30px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-card);
  border: 1px solid rgba(var(--color-primary-rgb), 0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-card-hover);
  }
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 40px;
`;

export const Card = styled(motion.div)`
  background: rgba(255, 255, 255, 0.95);
  border-radius: var(--border-radius);
  padding: 30px;
  box-shadow: var(--shadow-card);
  border: 1px solid rgba(var(--color-primary-rgb), 0.1);
  transition: transform 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  h3 {
    color: var(--color-primary);
    font-size: 1.5rem;
    font-weight: var(--font-weight-bold);
    margin-bottom: 15px;
    position: relative;
    padding-bottom: 15px;

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 60px;
      height: 3px;
      background: var(--color-primary-light);
      border-radius: 2px;
    }
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-card-hover);
  }
`;

export const ListStyled = styled(motion.ul)`
  list-style: none;
  padding: 0;
  margin: 20px 0;
`;

export const ListItem = styled(motion.li)`
  position: relative;
  padding-left: 25px;
  margin: 15px 0;
  font-size: 1.1rem;
  line-height: 1.6;
  
  &:before {
    content: '•';
    color: var(--color-primary);
    position: absolute;
    left: 0;
    top: 0;
  }
`;

export const Emphasis = styled.span`
  color: var(--color-primary);
  font-weight: 600;
`;
